
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useInView, useMotionValue, useSpring } from "framer-motion";

interface AnimatedCounterProps {
  value: number;
  className?: string;
  suffix?: string;
}

const AnimatedCounter = ({ value, className, suffix }: AnimatedCounterProps) => {
  const location = useLocation();
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, { damping: 60, stiffness: 200 });
  const isInView = useInView(ref, { margin: "-50px" });

  useEffect(() => {
    // Fonction pour démarrer ou redémarrer l'animation
    const startAnimation = () => {
      motionValue.set(0); // Réinitialiser à 0
      motionValue.set(value); // Lancer l'animation vers la valeur cible
    };

    if (isInView) {
      // Déclencher l'animation lorsque le composant devient visible ou que la page change
      startAnimation();

      // Mettre en place un intervalle pour répéter l'animation
      const interval = setInterval(() => {
        startAnimation();
      }, 6000);

      // Nettoyer l'intervalle lorsque le composant n'est plus visible ou est démonté
      return () => clearInterval(interval);
    }
  }, [isInView, value, motionValue, location]);

  useEffect(() => {
    const unsubscribe = springValue.on("change", (latest) => {
      if (ref.current) {
        ref.current.textContent = Intl.NumberFormat("en-US").format(
          Math.round(latest)
        );
      }
    });
    return unsubscribe;
  }, [springValue]);

  return (
    <div className={className}>
      <span ref={ref} />
      {suffix}
    </div>
  );
};

export default AnimatedCounter;
